// extracted by mini-css-extract-plugin
export default {"wrapper":"Step6Widget_wrapper__D7tDE","logo":"Step6Widget_logo__E5heW"};